import {
  Headings
} from '@sentara-health/optimahealth_web';
interface EmailPromptProps {
  setIsOpen: (response: any) => void;
}

const EmailPrompt = ({ setIsOpen }: EmailPromptProps) => {
  

  return (
          <Headings level={3} text={"Go Paperless Popup"} variant="regular" />
  );
}

export default EmailPrompt;